import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';
import { routes } from '../../routes';

const ShippingProcessing = lazy(() => import('./shippingProcessing'));
const CookiesPolicy = lazy(() => import('./cookiesPolicy'));
const FAQ = lazy(() => import('./faq'));
const PrivacyPolicy = lazy(() => import('./privacyPolicy'));
const ReturnPolicy = lazy(() => import('./returnPolicy'));
const KnowUs = lazy(() => import('./know-us'));

export const infoRoutes: RouteObject[] = [
  { path: routes.SHIPPING_PROCESSING, element: <ShippingProcessing /> },
  { path: routes.COOKIES_POLICY, element: <CookiesPolicy /> },
  { path: routes.RETURN_POLICY, element: <ReturnPolicy /> },
  { path: routes.PRIVACY_POLICY, element: <PrivacyPolicy /> },
  { path: routes.FAQ, element: <FAQ /> },
  { path: routes.KNOW_US, element: <KnowUs /> },
];
